<ae-content-load *ngIf="!linkLoaded"></ae-content-load>

<div id="elevaagendaedu" *ngIf="linkLoaded">
  <eae-header-navigation [href]="urlShowFatura" title="Portal de auto negociação"></eae-header-navigation>
  <main class="fullheight">
    <P>
      <img src="assets/img/simule.png">
    </P>
    <h1>Conheça o Portal de Autonegociação</h1>
    <p>Ganhe tempo e negocie suas faturas em aberto, sem precisar sair de casa.</p>
    
  </main>

  
  <nav>
    <ae-buttons>
      <ae-buttons-button>
        <a (click)="onGoPortal($event, linkData)">Ir para o portal <img src="assets/img/icons/externalink.svg"></a>
      </ae-buttons-button>
    </ae-buttons>
  </nav>
</div>
